// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/unserneuere-transporteristda-2-2/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const unserneuereTransporteristda22DE: PageEntry = {
  id: "post.unserneuere-transporteristda-2-2",
  locale: "de",
  slug: "unserneuere-transporteristda-2-2",
  seo: {
    title: "Campus Messe 2019 | Dietz GmbH",
    description: "Campus Messe 2019",
  },
  type: "post",
  h1: "Campus Messe 2019",
  blocks: [
    { kind: "heading", level: 2, text: "Campus Messe 2019" },
    { kind: "paragraph", text: "Liebe Studierende, wir haben ein Date! Am Donnerstag, den 14.11.19, sind wir von 9:30 Uhr bis 15:00 Uhr auf der Campus Messe der Hochschule Coburg zu finden. Wer sich über Einstiegsmöglichkeiten und Praktika informieren will, darf uns gerne dort besuchen oder unsere aktuellen Ausschreibungen unter https://www.dietz.eu/karriere/studenten einsehen – wir freuen uns drauf." }
  ],
};
